import { Model, go } from 'oderon-vue'

export const ProductType = new Model('/product-types')

ProductType.deactivate = (id) => go.post(`/product-types/${id}/deactivate`)
ProductType.reactivate = (id) => go.post(`/product-types/${id}/reactivate`)
